export class LogoutData{
    status: string;
    message: string;
}


// WEBPACK FOOTER //
// ./src/angular_library/models/logout-data.ts